import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allManagers } from 'app/mocks/data/park/managers'

import { api } from 'app/utils/constants'

import { Manager } from 'app/types/park/manager'
import { Technician, TechnicianPayload } from 'app/types/users/technician'

export const createTechnician = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.technicians.LIST}`,
    async ({ request }) => {
        const payload = await request.json()
        const payloadParsed = TechnicianPayload.safeParse(payload)

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Technician>(
            {
                id: 999,
                ...payloadParsed.data,
                client: allManagers.filter((manager: Manager) =>
                    payloadParsed.data.client.includes(manager.id),
                ),
            },
            {
                status: StatusCodes.CREATED,
            },
        )
    },
)
